import { useSelector } from 'react-redux';

import type { AssetBalances } from '@/ui/flux/balances/selectors/asset-balance.js';
import {
  balancesLoadedSelector,
  balancesSelector,
} from '@/ui/flux/balances/selectors/asset-balance.js';

type UseBalancesValue = {
  value: AssetBalances | {};
  loading: boolean;
};

function useBalances(): UseBalancesValue {
  const loaded = useSelector(balancesLoadedSelector);
  const balances = useSelector(balancesSelector);

  return {
    value: balances,
    loading: !loaded,
  };
}

export default useBalances;
